/* Muestra de varios libros. Sol y Luna solo cambian el papel de esta vista. */
(function () {
  'use strict';

  var root = document.querySelector('[data-lector]');
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  var catalogEl = document.querySelector('[data-lector-catalog]');
  var catalog = [];
  try { catalog = JSON.parse(catalogEl ? catalogEl.textContent : '[]'); } catch (e) { catalog = []; }
  if (!catalog.length) return;

  var statusEl = root.querySelector('[data-lector-status]');
  var bookEl = root.querySelector('[data-lector-book]');
  var leftSlot = root.querySelector('[data-lector-left]');
  var rightSlot = root.querySelector('[data-lector-right]');
  var rightSheet = root.querySelector('.lector__sheet--right');
  var spread = root.querySelector('[data-lector-spread]');
  var gate = root.querySelector('[data-lector-gate]');
  var note = root.querySelector('[data-lector-note]');
  var themeBtn = root.querySelector('[data-lector-theme]');
  var themeLabel = root.querySelector('[data-lector-theme-label]');
  var runas = root.querySelector('[data-lector-runas]');
  var runaImg = runas ? runas.querySelector('img') : null;
  var runaSrcs = runas && runas.dataset.srcs ? runas.dataset.srcs.split(',') : [];
  var section = root.closest('section');

  var book = catalog[0];
  var cursor = 0;
  var busy = false;
  var pending = 0;
  var turn = 0;
  var swipe = null;
  var swallowClick = false;
  var prevButtons = root.querySelectorAll('.lector__edge[data-lector-prev]');
  var nextButtons = root.querySelectorAll('.lector__edge[data-lector-next]');
  var stage = root.querySelector('[data-lector-stage]');

  function pair() {
    return window.matchMedia('(max-width: 700px)').matches ? 1 : 2;
  }

  function reduced() {
    var level = document.documentElement.getAttribute('data-motion');
    return level === 'off' || level === 'reduced' ||
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function limit() {
    return book.pages.length;
  }

  function paintSlot(slot, pageNumber) {
    slot.innerHTML = '';
    if (!pageNumber || pageNumber < 1 || pageNumber > limit()) return;
    var page = book.pages[pageNumber - 1];
    if (!page || !page.src) return;
    var img = document.createElement('img');
    img.src = page.src;
    img.alt = book.title + ', página ' + pageNumber;
    img.dataset.kind = page.kind || 'page';
    slot.appendChild(img);
  }

  function show() {
    var step = pair();
    var left = cursor + 1;
    var right = step === 2 ? cursor + 2 : cursor + 1;
    if (step === 2) paintSlot(leftSlot, left);
    paintSlot(rightSlot, step === 2 ? right : left);
    if (statusEl) {
      statusEl.textContent = step === 2 && right <= limit()
        ? left + ' – ' + Math.min(right, limit())
        : String(Math.min(left, limit()));
    }
    paintRunas();
    paintNav();
    paintEndNote();
  }

  var baseNote = '';

  function atGate() {
    return !!(gate && !gate.hidden);
  }

  function lastCursor() {
    var step = pair();
    var n = limit();
    if (n <= step) return 0;
    var rem = n % step;
    return n - (rem === 0 ? step : rem);
  }

  function atEnd() {
    return atGate() || cursor + pair() >= limit();
  }

  function paintNav() {
    var atStart = !atGate() && cursor <= 0;
    for (var i = 0; i < prevButtons.length; i++) prevButtons[i].disabled = atStart;
    for (var j = 0; j < nextButtons.length; j++) nextButtons[j].disabled = atEnd();
  }

  function writeNote() {
    if (!note) return;
    if (book.note) baseNote = book.note;
    else if (book.total) baseNote = 'Muestra de ' + book.pages.length + ' páginas. El libro tiene ' + book.total + '.';
    else baseNote = 'Muestra de ' + book.pages.length + ' páginas.';
    note.textContent = baseNote;
  }

  function paintEndNote() {
    if (!note || book.note) return;
    note.textContent = atEnd() ? baseNote + ' Hasta aquí llega la muestra.' : baseNote;
  }

  function paintRunas() {
    if (!runas) return;
    var on = root.classList.contains('lector--luna') && book.runas && runaSrcs.length;
    runas.hidden = !on;
    root.dataset.runas = on ? 'true' : 'false';
    if (!on || !runaImg) return;
    runas.dataset.spot = String(cursor % 4);
    runaImg.src = runaSrcs[cursor % runaSrcs.length];
  }

  function openGate() {
    if (spread) spread.hidden = true;
    if (gate) gate.hidden = false;
    if (runas) runas.hidden = true;
    if (statusEl) statusEl.textContent = 'Muestra';
    paintNav();
  }

  function closeGate() {
    if (gate) gate.hidden = true;
    if (spread) spread.hidden = false;
    cursor = lastCursor();
    show();
  }

  function select(id) {
    var next = null;
    for (var i = 0; i < catalog.length; i++) {
      if (catalog[i].id === id) next = catalog[i];
    }
    if (!next) return false;
    book = next;
    cursor = 0;
    busy = false;
    pending = 0;
    turn += 1;
    root.dataset.book = book.id;
    if (bookEl) bookEl.textContent = book.title;
    if (rightSheet) rightSheet.classList.remove('is-turning', 'is-turning-back');
    if (gate) gate.hidden = true;
    if (spread) spread.hidden = false;
    writeNote();
    show();
    return true;
  }

  function go(delta) {
    if (!delta) return;
    if (atGate()) {
      if (delta < 0) closeGate();
      return;
    }
    var next = cursor + delta * pair();
    if (next < 0 || next >= limit()) return;
    cursor = next;
    if (rightSheet) rightSheet.classList.remove('is-turning', 'is-turning-back');
    show();
  }

  function setLuna(on) {
    root.classList.toggle('lector--luna', on);
    if (themeBtn) {
      themeBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      themeBtn.setAttribute('aria-label', on ? 'Volver al sol' : 'Poner la luna');
    }
    if (themeLabel) themeLabel.textContent = on ? 'Luna' : 'Sol';
    try { sessionStorage.setItem('ch-lector-luna', on ? '1' : '0'); } catch (e) {}
    paintRunas();
  }

  function bookFromHash() {
    var hash = (location.hash || '').replace('#', '');
    if (hash === 'muestra') return 'astral';
    if (hash.indexOf('muestra-') === 0) return hash.slice('muestra-'.length);
    return '';
  }

  function reveal() {
    if (!section) return;
    // 'instant' ignores the theme's smooth scroll. 'auto' follows it, and that
    // animation stops halfway on the pinned chapters, so the book never arrives.
    section.scrollIntoView({ behavior: 'instant', block: 'start' });
  }

  function openFromHash(scroll) {
    var id = bookFromHash();
    if (!id || !select(id)) return false;
    if (scroll) {
      reveal();
      window.requestAnimationFrame(reveal);
      window.setTimeout(reveal, 60);
    }
    return true;
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-lector-theme]')) {
      setLuna(!root.classList.contains('lector--luna'));
      return;
    }
    if (swallowClick) {
      swallowClick = false;
      e.preventDefault();
      return;
    }
    if (e.target.closest('[data-lector-back]')) {
      e.preventDefault();
      closeGate();
      return;
    }
    if (e.target.closest('[data-lector-prev]')) {
      go(-1);
      return;
    }
    if (e.target.closest('[data-lector-next]')) go(1);
  });

  if (stage) {
    var swipedAt = 0;
    function turnBySwipe(dx, dy) {
      if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
      var now = Date.now();
      // A phone fires the touch and the pointer for the same gesture.
      if (now - swipedAt < 500) return;
      swipedAt = now;
      swallowClick = true;
      go(dx < 0 ? 1 : -1);
    }
    stage.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      swipe = { x: e.clientX, y: e.clientY, id: e.pointerId };
    });
    // Window, not the stage: the finger can leave the page, and capturing
    // the pointer would steal the click from the sheet buttons.
    window.addEventListener('pointerup', function (e) {
      if (!swipe || e.pointerId !== swipe.id) return;
      var dx = e.clientX - swipe.x;
      var dy = e.clientY - swipe.y;
      swipe = null;
      turnBySwipe(dx, dy);
    });
    window.addEventListener('pointercancel', function () { swipe = null; });
    // Kept apart from the pointer path: a phone cancels the pointer when the
    // finger slides, and that was wiping the gesture before touchend.
    var finger = null;
    stage.addEventListener('touchstart', function (e) {
      if (!e.changedTouches || !e.changedTouches.length) return;
      finger = { x: e.changedTouches[0].clientX, y: e.changedTouches[0].clientY };
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (!finger || !e.changedTouches || !e.changedTouches.length) return;
      var dx = e.changedTouches[0].clientX - finger.x;
      var dy = e.changedTouches[0].clientY - finger.y;
      finger = null;
      turnBySwipe(dx, dy);
    }, { passive: true });
    stage.addEventListener('touchcancel', function () { finger = null; });
  }

  window.addEventListener('resize', function () {
    if (atGate()) {
      paintNav();
      return;
    }
    var step = pair();
    var snapped = Math.floor(cursor / step) * step;
    cursor = snapped >= limit() ? lastCursor() : snapped;
    show();
  });

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#muestra"]');
    if (!link) return;
    // The browser's own hash scroll is smooth and dies on the pinned sections.
    e.preventDefault();
    var href = link.getAttribute('href');
    if (href && location.hash !== href) history.pushState(null, '', href);
    openFromHash(true);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
    if (e.target.closest('input, textarea, select')) return;
    var rect = root.getBoundingClientRect();
    var visible = rect.top < window.innerHeight * 0.85 && rect.bottom > 80;
    if (!visible && !root.contains(document.activeElement)) return;
    e.preventDefault();
    go(e.key === 'ArrowRight' ? 1 : -1);
  });

  window.addEventListener('hashchange', function () { openFromHash(true); });
  window.addEventListener('popstate', function () { openFromHash(true); });

  var stored = false;
  try { stored = sessionStorage.getItem('ch-lector-luna') === '1'; } catch (e) {}
  setLuna(stored);

  if (!openFromHash(true)) select(catalog[0].id);
})();
